<template>
  <div class="TopicHeader">

    <div class="inner_center">
      <h1 class="headline">
        专题精选 · 精彩设计正在发生
        <i class="icon_wave"/>
      </h1>

      <!-- 搜索功能 -->
      <div class="search-box">
        <input
          v-model="searchWord"
          type="text"
          placeholder="专题名/关键词"
          @keyup.enter="search"
          @input="input"
        >
        <i
          class="iconfont icon-chaxun2"
          @click="search"
        />
        <i
          v-if="searchWord.length"
          class="iconfont icon-cha"
          @click="clear"
        />
      </div>
    </div>

  </div>
</template>

<script>
import * as fnCommon from "@/fn/_fn";

export default {
  name: "TopicHeader",
  data() {
    return {
      searchWord: ''
    }
  },
  props: {
    topicSearchWord: {
      type: String,
      default: ''
    }
  },
  watch: {
    topicSearchWord: {
      handler(n) {
        this.searchWord = n;
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.searchWord = this.searchWord.replace(/[, ]/g, '')
      this.$emit('search', this.searchWord);
    },
    clear(){
      this.searchWord = '';
      this.search();
    },
    input() {
      fnCommon.fnBasic.listenSearchInput(this.searchKeyword)
    }
  }
}
</script>

<style lang="scss" scoped>
.TopicHeader {
  height: 292px;
  background: linear-gradient(360deg, rgba(245, 246, 250, 0) 0%, #FFF7F5 38%, #FFFDF4 100%);

  .inner_center {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 70px 0 0;

    .headline {
      font-size: 48px;
      font-weight: bold;
      color: #0A2540;
      line-height: 64px;
      letter-spacing: 4px;
      text-align: center;
      margin-bottom: 40px;
      position: relative;

      .icon_wave {
        @include BgImage(459px, 68px, 'topic/index/icon_wave.svg');
        @include Position(1, 3, -25px, -8px);
      }
    }

    .search-box {
      width: 533px;
      height: 56px;
      background: #FFFFFF;
      position: relative;
      box-shadow: 0px 0px 24px 0px rgba(250, 81, 105, 0.11);
      border-radius: 28px;

      input {
        display: inline-block;
        height: 100%;
        //background-color: pink;
        padding: 0 120px 0 24px;
        width: 100%;
        box-sizing: border-box;
        color: #001013;
        border: 1px solid transparent;
        border-radius: 28px;
        transition: all 0.5s ease-in-out;

        &::placeholder {
          color: rgba(0, 16, 19, 0.3);
          font-size: 14px;
        }

        &:focus {
          //border: 1px solid $color-primary;
          box-shadow: 0px 0px 24px 0px rgba(250, 81, 105, 0.16);
        }
      }

      .icon-chaxun2 {
        width: 80px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 22px;
        @include Position(1, 2, 0, 0);
        cursor: pointer;
        transition: all 0.5s ease-in-out;
        border-radius: 28px;
        color: #424866;

        @include ElementHover(#FFFFFF, '') {
          background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
        }
      }

      .icon-cha {
        font-size: 14px;
        @include Position(1, 2, 96px, 50%);
        transform: translateY(-50%);
        color: #59617F;
        cursor: pointer;

        @include ElementHover(#001013, '');
      }
    }
  }


}
</style>
